import {Injectable} from '@angular/core';
import {MatPaginatorIntl} from '@angular/material/paginator';
import { Subject } from 'rxjs';

@Injectable()
export class CustomPaginatorIntl implements MatPaginatorIntl {
  itemsPerPageLabel: string = 'Rækker pr. side:';
  nextPageLabel: string = 'Næste side';
  previousPageLabel: string = 'Forrige side';
  firstPageLabel: string = 'Første side';
  lastPageLabel: string = 'Sidste side';
  changes = new Subject<void>();

  getRangeLabel(page: number, pageSize: number, length: number): string {
    if (length === 0) {
      return `Side 1 af 1`;
    }
    const amountPages = Math.ceil(length / pageSize);
    return `Side ${page + 1} af ${amountPages}`;
  }
}
